module.exports = __webpack_public_path__ + "img/ex-pin-sports.d94a7fed.svg";